import * as React from 'react';

import styled from 'styled-components';

export interface LockIconProps {
  className?: string;
  color?: string;
  size?: number;
  isDark?: boolean;
}

export const LockIcon: React.FC<LockIconProps> = (props) => (
  <svg
    viewBox="0 0 16 16"
    width={16}
    height={16}
    className={`${props.className} ${props.isDark ? 'dark' : ''}`}
  >
    <StyledPath d="M12.15,6.67h-.15v-2.6c0-2.24-1.79-4.07-4-4.07s-4,1.82-4,4.07v2.6h-.15c-1.39,0-2.52,1.16-2.52,2.59v4.15c0,1.43,1.13,2.59,2.52,2.59H12.15c1.39,0,2.52-1.16,2.52-2.59v-4.15c0-1.43-1.13-2.59-2.52-2.59Zm-6.2-2.6c0-1.17,.92-2.12,2.05-2.12s2.05,.95,2.05,2.12v2.6H5.95v-2.6Zm6.7,9.34c0,.28-.22,.51-.5,.51H3.85c-.27,0-.5-.23-.5-.51v-4.15c0-.28,.22-.51,.5-.51H12.15c.27,0,.5,.23,.5,.51v4.15Z" />
  </svg>
);

export default styled(LockIcon)`
  width: ${(props) => (props.size ? `${props.size}px` : `16px`)};
  height: ${(props) => (props.size ? `${props.size}px` : `16px`)};
  &.dark {
    path {
      fill: ${({ theme }) => theme.colors.primary};
    }
  }
`;

const StyledPath = styled.path`
  fill: ${({ theme }) => theme.colors.background};
`;
